import { observer } from 'mobx-react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toast } from 'src/components/ui/Toast';
import { LoadingOverlay } from 'src/components/ui/LoadingOverlay';
import { AffiliateOverview } from 'src/sites/affiliate/AffiliateOverview';
import { AddAssetPage } from 'src/sites/assets/AddAssetPage';
import { AssetForumSite } from 'src/sites/assets/AssetForumSite';
import { AssetInvestmentPage } from 'src/sites/assets/AssetInvestmentPage';
import { AssetInvestorPayoutSite } from 'src/sites/assets/AssetInvestorPayoutSite';
import { AssetRecordsSite } from 'src/sites/assets/AssetRecordsSite';
import { AssetsSite } from 'src/sites/assets/AssetsSite';
import { AssetYearlyTaxSite } from 'src/sites/assets/AssetYearlyTaxSite';
import { EditAsset } from 'src/sites/assets/EditAsset';
import { AuthForgotPasswordSite } from 'src/sites/AuthForgotPasswordSite';
import AuthLoginSite from 'src/sites/AuthLoginSite';
import { AuthResetPasswordSite } from 'src/sites/AuthResetPasswordSite';
import { NotFoundSite } from 'src/sites/NotFoundSite';
import { AccountOverview } from 'src/sites/payment/AccountOverview';
import { AccountsOverview } from 'src/sites/payment/AccountsOverview';
import { authStore } from 'src/stores/AuthStore';
import { generalStore } from 'src/stores/GeneralStore';
import { IssuerOverview } from '../sites/issuer/IssuerOverview';
import { IssuerProfile } from '../sites/issuer/IssuerProfile';
import { IssuerTax } from '../sites/issuer/IssuerTax';
import { RentPayment } from '../sites/payment/RentPayment';
import AssetRoutes from './AssetRoutes';
import { NotAuthRoute } from './NotAuthRoute';
import { PrivateRoutes } from './PrivateRoutes';
import { Routes as RoutesData } from './Routes';
import AssetTypeProvider from 'src/context-providers/asset-type/AssetTypeProvider';
import { AssetApprovalPage } from 'src/sites/AssetApprovalPage';
import { PartnerMainPage } from 'src/sites/partner/Index';
import { Transactions } from 'src/sites/transaction/TransactionsPage';
import { AssetNotary } from '../sites/assets/AssetNotary';
import { AssetSerialNumber } from 'src/sites/assets/AssetSerialNumber';
import { RevenuePoolsOverview } from '../sites/revenuePools/RevenuePoolsOverview';
import { RevenuePoolCreateEdit } from '../sites/revenuePools/createEdit/RevenuePoolCreateEdit';
import { AssetPreorder } from '../sites/assets/AssetPreorder';

export const AppRouter = observer(() => {
  if (!authStore.isRehydrated) {
    console.log('AppRouter: authStore.isRehydrated is false');
    return <LoadingOverlay />;
  }

  return (
    <>
      <Router>
        <Routes>
          <Route element={<NotAuthRoute isAuthenticated={authStore.isAuthenticated} />}>
            <Route path={RoutesData.ROOT} element={<AuthLoginSite />} />
            <Route path={RoutesData.FORGOT_PASSWORD} element={<AuthForgotPasswordSite />} />
            <Route path={RoutesData.RESET_PASSWORD} element={<AuthResetPasswordSite />} />
          </Route>
          <Route element={<PrivateRoutes isAuthenticated={authStore.isAuthenticated} />}>
            <Route element={<AssetRoutes />}>
              <Route element={<AssetTypeProvider />}>
                <Route path={RoutesData.ASSETS.INVESTMENT} element={<AssetInvestmentPage />} />
                <Route path={RoutesData.ASSETS.EDIT} element={<EditAsset />} />
                <Route path={RoutesData.ASSETS.FORUM} element={<AssetForumSite />} />
                <Route path={RoutesData.ASSETS.NOTARY} element={<AssetNotary />} />
                <Route path={RoutesData.ASSETS.SERIAL_NUMBER} element={<AssetSerialNumber />} />
                <Route path={RoutesData.ASSETS.PREORDER} element={<AssetPreorder />} />
                <Route path={RoutesData.ASSETS.RECORDS} element={<AssetRecordsSite />} />
                <Route path={RoutesData.ASSETS.INVESTORPAYOUT} element={<AssetInvestorPayoutSite />} />
                <Route path={RoutesData.ASSETS.YEARLYTAXREPORT} element={<AssetYearlyTaxSite />} />
                <Route path={RoutesData.ASSETS.APPROVAL} element={<AssetApprovalPage />} />
              </Route>
            </Route>
            <Route element={<AssetTypeProvider />}>
              <Route path={RoutesData.ASSETS.ADD} element={<AddAssetPage />} />
            </Route>
            <Route path={RoutesData.ASSETS.ROOT} element={<AssetsSite />} />
            <Route path={RoutesData.PAYMENT.ROOT} element={<AccountsOverview />} />
            <Route path={RoutesData.PAYMENT.ACCOUNT} element={<AccountOverview />} />
            <Route path={RoutesData.PAYMENT.RENT} element={<RentPayment />} />

            <Route path={RoutesData.ISSUER.ROOT} element={<IssuerOverview />} />
            <Route path={RoutesData.ISSUER.PROFILE} element={<IssuerProfile />} />
            <Route path={RoutesData.ISSUER.CREATE} element={<IssuerProfile />} />
            <Route path={RoutesData.ISSUER.TAX} element={<IssuerTax />} />

            <Route path={RoutesData.AFFILIATE.ROOT} element={<AffiliateOverview />} />
            <Route path={RoutesData.TRANSACTIONS.ROOT} element={<Transactions status="reserved" />} />
            <Route path={RoutesData.TRANSACTIONS.PENDING} element={<Transactions status="reserved" />} />
            <Route path={RoutesData.TRANSACTIONS.COMPLETED} element={<Transactions status="success" />} />
            <Route path={RoutesData.PARTNER.ROOT} element={<PartnerMainPage />} />
            <Route path={RoutesData.REVENUE_POOLS.ROOT} element={<RevenuePoolsOverview />} />
            <Route path={RoutesData.REVENUE_POOLS.ADD} element={<RevenuePoolCreateEdit />} />
            <Route path={RoutesData.REVENUE_POOLS.EDIT} element={<RevenuePoolCreateEdit />} />
          </Route>
          <Route path="*" element={<NotFoundSite />} />
        </Routes>
      </Router>
      {generalStore.isLoading && <LoadingOverlay delayMs={300} />}
      <Toast />
    </>
  );
});
